import React, { Component } from "react";
import {
  apiAccountOptionAll,
  apiProfitReconciliation,
  apiAutoActionSubmissionApprove,
} from "../../Service/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Input } from "reactstrap";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  AppBar,
  Toolbar,
} from "@mui/material";
import { Storage, Close, Refresh, Cancel, Save } from "@mui/icons-material";
import moment from "moment";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { isNegative } from "../../../global.js";
const stylesListComent = {
  inline: {
    display: "inline",
  },
};

const stylesDialog = {
  appBar: {
    position: "relative",
    backgroundColor: "#03101e",
  },
  title: {
    marginLeft: 0,
    flex: 1,
    fontSize: 16,
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

let timer = null;

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

class AuditProfit extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      tableData: [],
      tableDisplay: [],
      tableDataProfitList: [],
      filter: "",
      startDateSelected: moment().locale("id").format("YYYY-MM-DD"),
      startDate: moment().locale("id").format("YYYY-MM-DD"),
      endDate: moment().locale("id").format("YYYY-MM-DD"),
      selectGroupAccountNumberId: null,
      DataGroupAccountNumber: [],
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      account_number: "",
      alias: "",
      balance: 0,
      type_currency: "Cents",
      total_profit: 0,
      total_all_profit: 0,
      arrDataDailyProfit: [],
      setOpenFilter: false,
      setOpenDetailProfit: false,
      loginInfo: "",
      tabIndex: 0,
      dataAccountDailyProfitNoHistory: [],
      openSyncConfirm: false,
      syncTarget: null,
      secretKey:
        "e69902f8ca7bf37cb776f323384f502205cb907e8935c118faf6803e239402d6",
    };

    this.tableArrDailyProfit = [
      {
        Header: "No",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "id",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 80,
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.id}
          </Typography>
        ),
      },
      {
        Header: "Date",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "date",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: ({ value }) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {moment(value).locale("en").format("ddd, DD MMM YYYY")}
          </Typography>
        ),
      },

      {
        Header: "Account Number",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "account_number",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.account_number}
          </Typography>
        ),
      },
      {
        Header: "Alias",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "alias",
        style: {
          textAlign: "left",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.alias}
          </Typography>
        ),
      },

      {
        Header: "Profit Summary",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "profit_summary",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                color:
                  isNegative(e.original.profit_summary) === true
                    ? "red"
                    : e.original.profit_summary === 0
                      ? "#000"
                      : "green",
                display: "inline-block",
                fontWeight: "800",
              }}
            >
              {isNegative(e.original.profit_summary) === true
                ? `${
                    e.original.type_currency === "Standart"
                      ? `${new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(e.original.profit_summary)}`
                      : `${Number(
                          parseFloat(e.original.profit_summary).toFixed(2),
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                        })}${e.original.type_currency === "Cents" ? "¢" : ""}`
                  }  `
                : e.original.profit_summary === 0
                  ? Number(
                      parseFloat(e.original.profit_summary).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })
                  : `+${
                      e.original.type_currency === "Standart" ? "$" : ""
                    }${Number(
                      parseFloat(e.original.profit_summary).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })}${e.original.type_currency === "Cents" ? "¢" : ""}`}
            </Typography>
          </>
        ),
      },

      {
        Header: "Profit Source",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "profit_source",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                color:
                  isNegative(e.original.profit_source) === true
                    ? "red"
                    : e.original.profit_source === 0
                      ? "#000"
                      : "green",
                display: "inline-block",
                fontWeight: "800",
              }}
            >
              {isNegative(e.original.profit_source) === true
                ? `${
                    e.original.type_currency === "Standart"
                      ? `${new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(e.original.profit_source)}`
                      : `${Number(
                          parseFloat(e.original.profit_source).toFixed(2),
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                        })}${e.original.type_currency === "Cents" ? "¢" : ""}`
                  }  `
                : e.original.profit_source === 0
                  ? Number(
                      parseFloat(e.original.profit_source).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })
                  : `+${
                      e.original.type_currency === "Standart" ? "$" : ""
                    }${Number(
                      parseFloat(e.original.profit_source).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })}${e.original.type_currency === "Cents" ? "¢" : ""}`}
            </Typography>
          </>
        ),
      },

      {
        Header: "Diff",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "diff",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                color:
                  isNegative(e.original.diff) === true
                    ? "red"
                    : e.original.diff === 0
                      ? "#000"
                      : "green",
                display: "inline-block",
                fontWeight: "800",
              }}
            >
              {isNegative(e.original.diff) === true
                ? `${
                    e.original.type_currency === "Standart"
                      ? `${new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(e.original.diff)}`
                      : `${Number(
                          parseFloat(e.original.diff).toFixed(2),
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                        })}${e.original.type_currency === "Cents" ? "¢" : ""}`
                  }  `
                : e.original.diff === 0
                  ? Number(
                      parseFloat(e.original.diff).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })
                  : `+${e.original.type_currency === "Standart" ? "$" : ""}${Number(
                      parseFloat(e.original.diff).toFixed(2),
                    ).toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })}${e.original.type_currency === "Cents" ? "¢" : ""}`}
            </Typography>
          </>
        ),
      },

      {
        Header: "Status",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "compare_status",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                color:
                  e.original.compare_status.toLowerCase() === "match"
                    ? "green"
                    : e.original.compare_status.toLowerCase() === "mismatch"
                      ? "red"
                      : "#000",
                display: "inline-block",
                fontWeight: "800",
              }}
            >
              {e.original.compare_status.toLowerCase() === "match"
                ? "Match"
                : e.original.compare_status.toLowerCase() === "mismatch"
                  ? "Mismatch"
                  : e.original.compare_status.toLowerCase()}
            </Typography>
          </>
        ),
      },
      {
        Header: "VPS",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "vps",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: function Cell(_ref) {
          var value = _ref.value;

          var text = "-";
          if (Array.isArray(value) && value.length > 0) {
            text = value
              .map(function (v) {
                return v && v.vps_name ? v.vps_name : "";
              })
              .filter(function (x) {
                return x;
              })
              .join(", ");
            if (!text) text = "-";
          }

          return (
            <Typography
              component="span"
              variant="body2"
              style={{ display: "inline-block" }}
            >
              {text}
            </Typography>
          );
        },
      },
      {
        Header: "Last Update",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "updated_at",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: ({ value }) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {value && moment(value).isValid()
              ? moment(value).locale("en").format("ddd, DD MMM YYYY HH:mm:ss")
              : "-"}
          </Typography>
        ),
      },
      {
        Header: "Action",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Button
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#2f55a2",
            }}
            onClick={() => this.openSyncOrderConfirm(e.original)}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Sync Order
            </Typography>
          </Button>
        ),
      },
    ];
  }

  componentDidMount() {
    let loginInfo = localStorage.getItem("loginInfo");
    loginInfo = JSON.parse(loginInfo);
    // console.log(loginInfo);
    this.setState({
      loginInfo: loginInfo,
    });
    const params = {};

    this.doLoadDailyProfit(params);
    this.doLoadAccountOption();

    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    clearTimeout(timer);
  }

  doLoadAccountOption = () => {
    apiAccountOptionAll()
      .then((res) => {
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            // console.log("data.records: ", data.records);
            // console.log("infoAccount: ", this.state.loginInfo.infoAccount);
            // console.log("loginInfo: ", this.state.loginInfo);
            if (this.state.loginInfo.logintype === 4) {
              const filterAccount = data.records.filter((item1) =>
                this.state.loginInfo.infoAccount.some(
                  (item2) => item2.account.toString() === item1.value,
                ),
              );

              // console.log("filterAccount: ", filterAccount);
              this.setState({
                DataGroupAccountNumber: filterAccount,
              });
            } else {
              this.setState({
                DataGroupAccountNumber: data.records,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadDailyProfit = (params) => {
    this.props.doLoading();
    apiProfitReconciliation(params)
      .then((res) => {
        this.props.doLoading();
        let data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            var dataDailyProfit = [];
            dataDailyProfit = data.records;

            for (var idx = 0; idx < dataDailyProfit.length; idx++) {
              dataDailyProfit[idx].id = idx + 1;
            }

            this.setState({
              arrDataDailyProfit: dataDailyProfit,
            });
          }
        }
      })
      .catch((err) => {
        this.props.doLoading();
        console.log(err);
      });
  };

  doSeacrhBydate = () => {
    const { selectGroupAccountNumberId } = this.state;
    if (this.state.startDate > this.state.endDate) {
      this.setState({
        openValidation: true,
        titleValidation: "Invalid Date?",
        titleBody: "End date is to small from start date",
      });
    } else {
      if (this.state.loginInfo.logintype === 1) {
        let params = {
          account_number: selectGroupAccountNumberId
            ? selectGroupAccountNumberId.value
            : "",
          start_date: this.state.startDate,
          end_date: this.state.endDate,
        };

        this.handleCloseFilter();
        this.props.doLoading();
        // }
        apiProfitReconciliation(params)
          .then((res) => {
            this.props.doLoading();
            // }
            let data = res.data;
            if (data.status === "OK") {
              if (data.records.length > 0) {
                var temp = [];
                temp = data.records;

                for (var idx = 0; idx < temp.length; idx++) {
                  temp[idx].id = idx + 1;
                }

                this.setState({
                  arrDataDailyProfit: temp,
                });
              }
            }
          })
          .catch((err) => {
            this.props.doLoading();
            console.log(err);
          });
      }
    }
  };

  generateRandomHex = (length) => {
    return [...Array(length)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join("");
  };

  pressReset = () => {
    this.setState({
      dataAccountDailyProfitNoHistory: [],
    });
    this.setState({
      tableData: [],
      arrDataDailyProfit: [],
      tableDataProfitList: [],
      startDate: moment().locale("id").format("YYYY-MM-DD"),
      endDate: moment().locale("id").format("YYYY-MM-DD"),
    });
    if (this.state.loginInfo.logintype === 1) {
      const params = {};
      this.doLoadDailyProfit(params);
    }
  };

  openSyncOrderConfirm = (row) => {
    this.setState({
      openSyncConfirm: true,
      syncTarget: row,
    });
  };

  closeSyncOrderConfirm = () => {
    this.setState({
      openSyncConfirm: false,
      syncTarget: null,
    });
  };

  doSyncOrderSubmit = () => {
    var target = this.state.syncTarget;
    if (!target) return;

    this.closeSyncOrderConfirm();
    this.props.doLoading();

    const params = {
      category: "SYNC_ORDER",
      subCategory: "",
      ticket_id: this.generateRandomHex(16),
      secretKey: this.state.secretKey,
      data: {
        account_id: target.account_number,
        client_id: this.state.loginInfo.phoneno,
        executor: this.state.loginInfo.name,
        date: target.date,
        note: `Request sync order for account ${target.account_number} on date ${target.date} from Audit Profit page.`,
      },
    };

    console.log("Submitting sync order with params: ", params);

    apiAutoActionSubmissionApprove(params)
      .then((res) => {
        this.props.doLoading();
        var data = res.data;

        if (data.status === true) {
          this.pressReset();
          this.setState({
            openValidation: true,
            titleValidation: "Success",
            titleBody:
              "Sync order request has been submitted for account " +
              target.account_number +
              ".",
          });
        } else {
          this.setState({
            openValidation: true,
            titleValidation: "Failed",
            titleBody: data.message || "Failed to submit sync order.",
          });
        }
      })
      .catch((err) => {
        this.props.doLoading();
        this.setState({
          openValidation: true,
          titleValidation: "Error",
          titleBody: err && err.message ? err.message : "Request error.",
        });
      });
  };

  getPreviousDay(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous;
  }

  setStartDate = (e) => {
    this.setState({ startDate: e.target.value });
  };
  setEndDate = (e) => {
    this.setState({ endDate: e.target.value });
  };

  handleChangeAccountNumber = (selectGroupAccountNumberId) => {
    this.setState({
      selectGroupAccountNumberId,
    });
  };

  handleCloseValidationAlert = () => {
    this.setState({
      openValidation: false,
      titleValidation: "",
      titleBody: "",
    });
  };

  renderValidationAlert = () => {
    return (
      <Dialog
        open={this.state.openValidation}
        onClose={this.handleCloseValidationAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="label-title-alert">{this.state.titleValidation}</div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <div className="title-body-alert"> {this.state.titleBody} </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton
            style={{ backgroundColor: "#f2f2f2" }}
            onClick={this.handleCloseValidationAlert}
          >
            <Close />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  };

  handleOpenFilter = () => {
    this.setState({
      setOpenFilter: true,
    });
  };

  handleCloseFilter = () => {
    this.setState({
      setOpenFilter: false,
    });
  };

  renderDialogFilter = () => {
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={this.state.setOpenFilter}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography variant="h5" style={stylesDialog.title}>
              Daily Profit Filter
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseFilter()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent dividers>
          <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  Account Number
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Select
                  classNamePrefix="select"
                  placeholder="Select a account"
                  value={this.state.selectGroupAccountNumberId}
                  onChange={this.handleChangeAccountNumber}
                  options={this.state.DataGroupAccountNumber}
                  styles={{
                    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  menuPlacement="top"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  Start Date
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Input
                  autoComplete="off"
                  type="date"
                  name="date"
                  id="exampleDate"
                  value={this.state.startDate}
                  onChange={this.setStartDate}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  End Date
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Input
                  autoComplete="off"
                  type="date"
                  name="date"
                  id="exampleDate"
                  value={this.state.endDate}
                  onChange={this.setEndDate}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#d0021b",
            }}
            startIcon={<Cancel />}
            onClick={() => this.handleCloseFilter()}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#004dcf",
            }}
            startIcon={<Save />}
            onClick={() => this.doSeacrhBydate()}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Filter
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderTable = () => {
    if (this.state.arrDataDailyProfit.length > 0) {
      return (
        <ReactTable
          ref={(r) => (this.reactTable = r)}
          data={this.state.arrDataDailyProfit}
          columns={this.tableArrDailyProfit}
          style={{ backgroundColor: "#f2f2f2" }}
          filterable
          defaultFilterMethod={defaultFilterMethod}
          defaultPageSize={500}
          showPageJump={false}
          showPageSizeOptions={false}
          showPagination={false}
        />
      );
    } else {
      return (
        <Typography
          sx={{ width: "33%", flexShrink: 0 }}
          style={{ fontWeight: "bold" }}
        >
          No data available
        </Typography>
      );
    }
  };

  renderTableAccountNoHistory = () => {
    if (this.state.dataAccountDailyProfitNoHistory.length > 0) {
      return (
        <ReactTable
          ref={(r) => (this.reactTable = r)}
          data={this.state.dataAccountDailyProfitNoHistory}
          columns={[
            {
              Header: "No",
              headerStyle: { fontWeight: "bold", fontSize: 14 },
              accessor: "id",
              style: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              width: 80,
              Cell: (e) => (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    display: "inline-block",
                  }}
                >
                  {e.original.id}
                </Typography>
              ),
            },
            {
              Header: "VPS",
              headerStyle: { fontWeight: "bold", fontSize: 14 },
              accessor: "vpsName",
              style: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              Cell: (e) => (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    display: "inline-block",
                  }}
                >
                  {e.original.vpsName}
                </Typography>
              ),
            },
            {
              Header: "Account",
              headerStyle: { fontWeight: "bold", fontSize: 14 },
              accessor: "account_number",
              style: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              Cell: (e) => (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    display: "inline-block",
                  }}
                >
                  {e.original.account_number}
                </Typography>
              ),
            },
            {
              Header: "Alias",
              headerStyle: { fontWeight: "bold", fontSize: 14 },
              accessor: "alias",
              style: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              Cell: (e) => (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    display: "inline-block",
                  }}
                >
                  {e.original.alias}
                </Typography>
              ),
            },
          ]}
          style={{ backgroundColor: "#f2f2f2" }}
          filterable
          defaultFilterMethod={defaultFilterMethod}
          defaultPageSize={500}
          showPageJump={false}
          showPageSizeOptions={false}
          showPagination={false}
        />
      );
    }
  };

  doRowView = (item) => {
    // console.log(item);
    this.setState({
      setOpenDetailProfit: true,
      startDateSelected: item.last_update_at,
    });
    this.doApiListProfit(item);
  };

  renderSyncOrderConfirm = () => {
    var t = this.state.syncTarget;

    return (
      <Dialog
        open={this.state.openSyncConfirm}
        onClose={this.closeSyncOrderConfirm}
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle>
          <div className="label-title-alert">Confirm Sync Order</div>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText>
            <div className="title-body-alert">
              This will sync orders for:
              <br />
              <b>Account:</b> {t ? t.account_number : "-"}
              <br />
              <b>Alias:</b> {t ? t.alias || "-" : "-"}
              <br />
              <br />
              Do you want to continue?
            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="medium"
            style={{ backgroundColor: "#d0021b" }}
            startIcon={<Cancel />}
            onClick={this.closeSyncOrderConfirm}
          >
            <Typography
              variant="button"
              style={{ color: "#fff", textTransform: "capitalize" }}
            >
              Cancel
            </Typography>
          </Button>

          <Button
            variant="contained"
            size="medium"
            style={{ backgroundColor: "#004dcf" }}
            startIcon={<Save />}
            onClick={this.doSyncOrderSubmit}
          >
            <Typography
              variant="button"
              style={{ color: "#fff", textTransform: "capitalize" }}
            >
              Yes, Sync
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography
                      component="span"
                      variant="h1"
                      style={
                        (stylesListComent.inline,
                        {
                          fontSize: 20,
                          color: "#000",
                          fontWeight: "bold",
                        })
                      }
                    >
                      Audit Profit
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 16 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#006b76",
                          }}
                          startIcon={<Storage />}
                          onClick={() => this.handleOpenFilter()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Filter
                          </Typography>
                        </Button>
                      </div>
                      <div style={{ marginRight: 0 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#1273DE",
                          }}
                          startIcon={<Refresh />}
                          onClick={() => this.pressReset()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <div className="box-container">{this.renderTable()}</div>
        {this.renderSyncOrderConfirm()}
        {this.renderValidationAlert()}
        {this.renderDialogFilter()}
      </Box>
    );
  }
}
export default AuditProfit;
